import { createThemedUseStyles } from "theme";

export default createThemedUseStyles(theme => ({
  validation: {
    color: theme.pallette.error
  }
}));
